import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Allbooks.css";
import { CircularProgress } from "@material-ui/core";
import BookCard from "../Components/BookCard";

function Allbooks() {
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchBooks = async () => {
      try {
        const res = await axios.get(`${API_URL}api/books/allbooks`);
        setBooks(res.data);
        setLoading(false);
      } catch (err) {
        console.log(err);
        setLoading(false);
      }
    };

    const fetchCategories = async () => {
      try {
        const res = await axios.get(`${API_URL}api/categories/allcategories`);
        setCategories(res.data);
      } catch (err) {
        console.log(err);
      }
    };

    fetchBooks();
    fetchCategories();
  }, [API_URL]);

  const handleSearch = async () => {
    if (searchTerm.trim() === "") {
      const res = await axios.get(`${API_URL}api/books/allbooks`);
      setBooks(res.data);
      return;
    }
    
    try {
      const res = await axios.get(`${API_URL}api/books/search?q=${searchTerm}`);
      setBooks(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  const handleCategoryFilter = async (categoryId) => {
    setSelectedCategory(categoryId);
    
    if (!categoryId) {
      const res = await axios.get(`${API_URL}api/books/allbooks`);
      setBooks(res.data);
      return;
    }
    
    try {
      const res = await axios.get(`${API_URL}api/books?category=${categoryId}`);
      setBooks(res.data.books || []);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="books-page">
      <div className="books-header">
        <h1>Library Collection</h1>
        <div className="search-filter-container">
          <div className="search-container">
            <input
              type="text"
              placeholder="Search books by title, author, or ISBN..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
            />
            <button onClick={handleSearch}>Search</button>
          </div>
          <div className="filter-container">
            <select 
              value={selectedCategory} 
              onChange={(e) => handleCategoryFilter(e.target.value)}
            >
              <option value="">All Categories</option>
              {categories.map((category) => (
                <option key={category._id} value={category._id}>
                  {category.categoryName}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      {loading ? (
        <div className="loading-container">
          <CircularProgress />
        </div>
      ) : (
        <div className="books">
          {books.length > 0 ? (
            books.map((book) => (
              <BookCard key={book._id} book={book} />
            ))
          ) : (
            <div className="no-books">
              <p>No books found. Try a different search term or category.</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default Allbooks;
